import Select, { components } from 'react-select';
import { TbGridDots } from 'react-icons/tb';
import { HiChevronDown } from 'react-icons/hi';
import Form from 'react-bootstrap/Form';
import { useEffect, useState } from 'react';
import { FaSpinner } from 'react-icons/fa'; // Spinner icon
import { partnerDropdown } from '../../../Redux/qms/action';

const PartnerDropDown = ({ lockboxformik, isSingle = false, width = "250px", name = "partner",fontSize = '17px' }) => {
	const [isFocusedPartner, setIsFocusedPartner] = useState(false);
	const [partnerlist, setPartnerlist] = useState([]);
	const [isLoadingPartners, setIsLoadingPartners] = useState(false);

	const DropdownIndicator = ({ state, ...props }) => {
		return (
			<components.DropdownIndicator {...props}>
				{isLoadingPartners ? (
					<FaSpinner className="spinner" style={{ fontSize: "1.5em", animation: "spin 1s linear infinite" }} />
				) : lockboxformik.values?.[state]?.length > 1 ? (
					<TbGridDots style={{ fontSize: "1.5em" }} />
				) : (
					<HiChevronDown style={{ fontSize: "1.5em" }} />
				)}
			</components.DropdownIndicator>
		);
	};

	useEffect(() => {
		let apiTimeout = null;

		setIsLoadingPartners(true); // Start loading

		apiTimeout = setTimeout(() => {
			partnerDropdown()((response) => {
				setIsLoadingPartners(false); // End loading

				if (response?.status) {
					setPartnerlist(response?.data || []);
				}
			});
		}, 600);

		return () => clearTimeout(apiTimeout);
	}, []); // Empty dependency array since partners are loaded once

	const handlePartners = (selectedpartner) => {
		lockboxformik.setFieldValue(name, !isSingle ? selectedpartner.map(i => i.value) : [selectedpartner?.value]);
	};

	
	const value = !isSingle
		? partnerlist?.filter(i => lockboxformik.values?.[name]?.includes(i.value))
		: partnerlist?.filter(i => lockboxformik.values?.[name]?.includes(i.value));

	return (
		<div style={{ width: `${width}` }}>
			<Form.Group>
				<Select
					className="basic-single select-search-facility"
					classNamePrefix="select"
					isDisabled={isLoadingPartners}
					isMulti={!isSingle}
					tabSelectsValue={false}
					closeMenuOnSelect={isSingle}
					value={value}
					name={name}
					components={{
						DropdownIndicator: (props) => <DropdownIndicator {...props} state={name} />
					}}
					options={partnerlist}
					onFocus={() => setIsFocusedPartner(true)}
					onBlur={() => setIsFocusedPartner(false)}
					onChange={handlePartners}
					placeholder="Select Partner"
					menuPortalTarget={document.body}
					styles={{ 

						container: (styles) => ({
							...styles,
							borderRadius: "9px"
						}),
						placeholder: (styles) => ({
							...styles,
							fontSize: fontSize
						}),
						control: (styles, state) => ({
							...styles,
							backgroundColor: "hsl(204deg 33.33% 97.06%)",
							borderStyle: "none",
							boxShadow: "none",
							borderRadius: "10px",
							maxHeight: state.isFocused ? "auto" : "30px"
						}),
						indicatorSeparator: (styles) => ({
							...styles,
							width: "0px",
							minHeight: "20px"
						}),
						valueContainer: (styles, state) => ({
							...styles,
							maxHeight: isFocusedPartner ? "auto" : "30px"
						}),
						menuPortal: (styles) => ({
							...styles,
							zIndex: 9999
						})
					}}
				/>
				{lockboxformik.errors?.[name] &&
					<span className='text-danger'>{lockboxformik.errors?.[name]}</span>
				}
			</Form.Group>
		</div>
	);
};

export default React.memo(PartnerDropDown);